import { createFileRoute } from '@tanstack/react-router'
import { HelpArticlePage } from '@/features/help/help-page'
export const Route = createFileRoute('/_console/help/$slug')({ component: Article })
function Article() { const { slug } = Route.useParams(); return <HelpArticlePage key={slug} slug={slug} /> }
